import Button from '@mui/material/Button'
import TextFieldForm from './TextFieldForm'
import { useState } from 'react'
import { LuPlus } from 'react-icons/lu'

interface TokenInsertProps {
  show?: boolean
  onCreate: (name: string) => void
}

const TokenInsert = ({ show, onCreate }: TokenInsertProps) => {
  const [showState, setShowState] = useState<boolean>(!!show)

  return showState ? (
    <TextFieldForm
      autoFocus
      label="Key Name"
      placeholder="Key"
      onSubmit={onCreate}
      onCancel={() => setShowState(false)}
    />
  ) : (
    <Button onClick={() => setShowState(true)} startIcon={<LuPlus />} size="small" variant="outlined">
      Add Key
    </Button>
  )
}

export default TokenInsert
